import React, { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { fetchFilterOptions } from '../actions';
import { saveUser, cancelEdit, deleteUser } from '../actions';

import css from './edit-user-drawer.css';

// Material UI Library
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';

class EditUserDrawer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeFilters: {},
      open: false,
    };
    this.userAttributes = {
      id: this.props.user.id,
      firstName: this.props.user.firstName,
      lastName: this.props.user.lastName,
      email: this.props.user.email,
    };
  }

  componentDidMount() {
    const _this = this;
    setTimeout(function() {
      _this.setState({ open: true });
    });
  }

  handleDeleteUser = () => {
    this.props.dispatch(deleteUser(this.userAttributes));
    this.setState({ open: false });
  };

  handleSaveUser = () => {
    const _this = this;
    this.setState({ open: false });
    setTimeout(function() {
      _this.props.dispatch(saveUser( _this.userAttributes ));
    });
  };

  handleChange = (ref, e) => {
    this.userAttributes[ref] = e.target.value;
  };

  handleCancel = () => {
    const _this = this;
    this.setState({ open: false });
    setTimeout(function() {
      _this.props.dispatch( cancelEdit(_this.props.user.id) );
    });
  };

  displayLoading = () => {
    if (!this.props.user || this.props.isFetching) {
      return <CircularProgress />
    }
  };

  displayForm = () => {
    const styles = {
      buttonsContainer: {
        padding: '12px 0',
        display: 'flex',
        justifyContent: 'space-between',
      }
    };
    if (!this.props.user || this.props.isFetching) {
      return <div></div>
    }
    else {
      return(
        <div className={css.formContainer}>
          <TextField
            id="user-firstname"
            fullWidth={true}
            defaultValue={this.userAttributes.firstName || this.props.user.firstName}
            onChange={this.handleChange.bind(this, 'firstName')}
          />
          <TextField
            id="user-lastname"
            fullWidth={true}
            defaultValue={this.userAttributes.lastName || this.props.user.lastName}
            onChange={this.handleChange.bind(this, 'lastName')}
          />
          <TextField
            id="user-email"
            fullWidth={true}
            defaultValue={this.userAttributes.email || this.props.user.email}
            onChange={this.handleChange.bind(this, 'email')}
          />
          <div style={styles.buttonsContainer}>
            <FlatButton
              label="Delete"
              secondary={true}
              onClick={this.handleDeleteUser}
            />
            <RaisedButton
              label="Save"
              primary={true}
              onClick={this.handleSaveUser}
            />
          </div>
        </div>
      )
    }
  };

  render() {
    const drawerStyle = {
      position: 'absolute',
      top: 'auto',
    };

    return (
      <Drawer
        open={this.state.open}
        containerStyle={drawerStyle}
        openSecondary={true}
        width={400}
      >
        <AppBar
          title="Edit User"
          showMenuIconButton={false}
          iconElementRight={
            <IconButton onTouchTap={this.handleCancel}>
              <NavigationClose />
            </IconButton>
          }
        >
        </AppBar>
        {this.displayLoading()}
        {this.displayForm()}
        </Drawer>
    );
  }
}

export default connect()(EditUserDrawer);



/** WEBPACK FOOTER **
 ** ./containers/EditUserDrawer.js
 **/